import React from 'react';
// import PropTypes from 'prop-types';
import { Avatar, Icon, List, ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: '00a0af',
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
  },
  error: {
    backgroundColor: '#FF0303',
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
  }
}));
const UsernameConditionsIndicator = props => {
  // const {numberValid, characterValid, identificationValid, charNumberValid, numberCharacters} = props
  const { validators } = props
  const classes = useStyles();
  return (
    <div className="validation">
      <List dense className={classes.root}>
        {validators.map(row => {
          return <ListItem key={row.tittle}>
            <ListItemAvatar>
              <Avatar className={row.validationState ? classes.success : classes.error}> <Icon></Icon></Avatar>
            </ListItemAvatar>
            <ListItemText primary={row.tittle} />
          </ListItem>

        })}
        {/* <ListItem>
                <ListItemAvatar>
                  <Avatar className={numberValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={'Caracter numérico'} />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar className={characterValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={'Letra minúscula / mayúscula'} />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar className={identificationValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={'No contenga la identificación'} />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar className={charNumberValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={`Mínimo ${numberCharacters} caracteres`} />
            </ListItem> */}
      </List>
    </div>
  );
};

UsernameConditionsIndicator.propTypes = {
  // numberValid: PropTypes.bool.isRequired,
  // characterValid: PropTypes.bool.isRequired,
  // identificationValid: PropTypes.bool.isRequired,
  // charNumberValid: PropTypes.bool.isRequired,
  // numberCharacters: PropTypes.string.isRequired
};

export default UsernameConditionsIndicator;
